// eslint-disable-next-line no-restricted-imports
import { OrderListItemFragment } from 'api/generated/graphql';
import { OrdersListItemData } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity/account/order';
import { OrderStatusType } from 'api/types/entity/account/order/orderStatusType';

export const parseOrdersListItemData = (
  data: OrderListItemFragment
): OrdersListItemData => ({
  id: data.id,
  status: OrderStatusType[data.status],
  number: data.number ?? undefined,
  createdAt: new Date(data.createdAt),
  signedAt: data.signedAt ? new Date(data.signedAt) : undefined,
  operationType: OrderOperationType[data.operationType],
  startDate: data.startDate ? new Date(data.startDate) : undefined,
  endDate: data.endDate ? new Date(data.endDate) : undefined,
  closedDate: data.closedDate ? new Date(data.closedDate) : undefined,
  isin: data.financialInstrument.isin.value,
  currency:
    data.transactionVolume?.currency ??
    data.transferVolume?.currency ??
    undefined,
  unitPrice:
    data.transactionVolume?.unitPrice ??
    data.transferVolume?.unitPrice ??
    undefined,
  quantity: data.transactionVolume?.quantity || data.transferVolume?.quantity,
  transactionAmount:
    data.transactionVolume?.transactionAmount ??
    data.transferVolume?.transactionAmount ??
    undefined,
});
